import React, {useCallback, useEffect} from 'react';
import {useNavigate} from 'react-router';
import {Concept} from 'types';
import {useLocalization} from 'localization';
import {FlexBox, Scene, Text} from 'components';
import {useOpenSearch, useSceneExtensionsContext} from 'sceneExtensions';
import {PrizesToolbar} from './components';

export const SearchPrizesScene: React.FC = () => {
  const {t} = useLocalization();
  const navigate = useNavigate();
  const {currentExtension} = useSceneExtensionsContext();
  const openSearch = useOpenSearch();

  const customHandleEditPrize = useCallback(
    (_: Concept, entityId: string) => {
      navigate(`/prize/${entityId}`);
    },
    [navigate],
  );

  const customHandleAddPrize = useCallback(() => {
    navigate(`/prize/new`);
  }, [navigate]);

  const handleOpenSearch = useCallback(() => {
    openSearch({
      entity: Concept.prize,
      canEditEntity: () => true,
      handleEditEntity: customHandleEditPrize,
      handleAddEntity: customHandleAddPrize,
    });
  }, [customHandleAddPrize, customHandleEditPrize, openSearch]);

  // Open search on mount
  useEffect(() => {
    handleOpenSearch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Scene
      browserTitle={t('appbar.prizes')}
      rightPanelConfig={currentExtension?.panelConfig}>
      <Scene.Header>
        <FlexBox horizontal justifyContent={'space-between'}>
          <Text variant="h1">{'Litterære priser'}</Text>
          <PrizesToolbar
            onSearch={handleOpenSearch}
            onAdd={customHandleAddPrize}
          />
        </FlexBox>
      </Scene.Header>
      <Scene.Content>{null}</Scene.Content>
      {currentExtension ? (
        <Scene.RightPanel>
          {currentExtension.renderRightPanel()}
        </Scene.RightPanel>
      ) : null}
    </Scene>
  );
};
